import type { AnyAction } from 'redux';

import type { AccommodationState } from '@/interfaces';
import { defaultState } from './defaultState';
import { filterReducer } from './filterActions';
import { reducer as searchResultsReducer } from '@/ducks/searchResults/reducer';
import { reducer as bookingReducer } from '@/ducks/booking/reducer';
import { hotelPageReducer } from './hotelPageActions';
import { directPricesReducer } from './directPricesActions';
import { mapReducer } from './mapActions';

export const reducer = (state: AccommodationState = defaultState, action: AnyAction) => ({
    ...state,
    filters: filterReducer(state.filters, action),
    searchResults: searchResultsReducer(state.searchResults, action),
    hotelPage: hotelPageReducer(state.hotelPage, action),
    directPrices: directPricesReducer(state.directPrices, action),
    map: mapReducer(state.map, action),
    booking: bookingReducer(state.booking, action),
});
